export enum RangeErrorType {
	end = 'end',
	start = 'start',
}
